import request from './request'
const activity = 'ACTIVITY-SERVE'

export function findList(data) {
  return request({
    url: activity + '/account-period/findList',
    method: 'post',
    data
  })
}

export function findAmountDealers(data) {
  return request({
    url: activity + '/dealer-amount/findList',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: activity + '/account-period/save',
    method: 'post',
    data
  })
}

export function findById(data) {
  return request({
    url: activity + '/account-period/findById?id=' + data,
    method: 'get'
  })
}

export function saveDealerBatch(data) {
  return request({
    url: activity + '/dealer-amount/saveBatch',
    method: 'post',
    data
  })
}

export function deleted(data) {
  return request({
    url: activity + '/account-period/delete?id=' + data,
    method: 'get'
  })
}

export function deleteDealerBatch(data) {
  return request({
    url: activity + '/dealer-amount/deleteBatch',
    method: 'post',
    data
  })
}

// export function findById(data) {
//   return request({
//     url: activity + '/dealer-amount/findById?id=' + data,
//     method: 'get'
//   })
// }

export function findDealers(data) {
  return request({
    url: activity + '/dealer-amount/findDealers',
    method: 'post',
    data
  })
}

// 获取日常广宣核销剩余费用
export function getRemainFee(data) {
  return request({
    url: activity + '/account-period/getRemainFee',
    method: 'post',
    data
  })
}

export function exportTemp(data) {
  return request({
    url: activity + '/dealer-amount/exportTemp',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 导入经销商费用
export function uploadDealerAmount(data) {
  return request({
    url: activity + '/dealer-amount/upload',
    method: 'post',
    timeout: 600000,
    data
  })
}

// 获取某个经销商广宣费用
export function findDealerLimit(data) {
  return request({
    url: activity + '/account-period/findDealerLimit',
    method: 'post',
    data
  })
}
